import { useEffect, useRef, useState } from "react";
import { useTheme } from "../context/ThemeContext";
import { FaTimes } from "react-icons/fa";
import { useOrderCrud } from "../context/OrderCrudContext";
import CreateOrderItemRow from "./Forms/FormsSteppers/Orders/CreateOrderItemRow";
import update from 'immutability-helper';
import { safeFormatCLP } from "../util/format";
import useAxios from "../hooks/useAxios";
import { useFeedBack } from "../context/FeedBackContext";
import { useNavigate } from "react-router-dom";

const OrderSidebar = ({ show, setShow }) => {

    const navigate = useNavigate();

    const { setCustomAlert } = useFeedBack();

    const { data, setData } = useOrderCrud();

    const overlayRef = useRef();

    const { background } = useTheme();

    const [total, setTotal] = useState(0);

    const [{ loading: createLoading }, createOrder] = useAxios({ url: `/orders`, method: 'POST' }, { manual: true, useCache: false });

    const [{ }, deleteAutoSave] = useAxios({ url: `/auto-saves`, method: 'DELETE' }, { useCache: false, manual: true });

    useEffect(() => {
        var total = 0;
        data?.orderItems?.forEach((item) => {
            total = total + (item?.price * item?.quantity)
        });

        setTotal(total);
    }, [data?.orderItems]);

    const handleOverlay = (e) => {
        if (e.target == overlayRef?.current) {
            setShow?.(false);
        }
    }

    const handleArrayChange = (e, index, arrayName) => {
        const newArrayValues = update(data?.[arrayName], { [index]: { [e.target.name]: { $set: e.target.value } } });
        setData((oldData) => {
            return {
                ...oldData,
                [arrayName]: newArrayValues
            }
        });
    }

    const handleRemove = (index) => {
        data?.orderItems?.splice(index, 1);

        var total = 0;

        data?.orderItems?.forEach((item) => {
            total = item?.price * item?.quantity + total;
        });

        setTotal(total);

        setData((oldData) => {
            return {
                ...oldData,
                orderItems: data?.orderItems
            }
        });
    }

    const handleCreateOrder = () => {

        var formData = new FormData();

        const hasAnyChargePerForm = data?.chargePerForm || data?.orderItems?.some(i => i?.chargePerForm);
        if (hasAnyChargePerForm) {
            formData.append('feeForFormulating', 1);
            if (data?.authorizedBy) formData.append('authorizedBy', data?.authorizedBy);
            if (data?.account) formData.append('account', data?.account);
            if (data?.seven) formData.append('seven', data?.seven);
        }

        formData.append('serviceId', data?.service?.id || null);

        data?.orderItems?.forEach((orderItem, index) => {
            formData.append(`orderItems[${index}][quantity]`, orderItem?.quantity || null);
            if (orderItem?.productId) {
                formData.append(`orderItems[${index}][productId]`, orderItem?.productId || null);
            } else {
                formData.append(`orderItems[${index}][name]`, orderItem?.name || null);
                if (orderItem?.image) formData.append(`orderItems[${index}][image]`, orderItem?.image || null, orderItem?.image?.name);
                if (orderItem?.file) formData.append(`orderItems[${index}][file]`, orderItem?.file || null, orderItem?.file?.name);
                formData.append(`orderItems[${index}][category_id]`, orderItem?.category_id || null);
                formData.append(`orderItems[${index}][providerName]`, orderItem?.providerName || null);
                formData.append(`orderItems[${index}][description]`, orderItem?.description || null);
                formData.append(`orderItems[${index}][price]`, orderItem?.price || null);
                if (orderItem?.chargePerForm) {
                    formData.append(`orderItems[${index}][feeForFormulating]`, 1);
                    formData.append(`orderItems[${index}][authorizedBy]`, orderItem?.authorizedBy || '');
                    formData.append(`orderItems[${index}][account]`, orderItem?.account || '');
                    formData.append(`orderItems[${index}][seven]`, orderItem?.seven || '');
                } else {
                    formData.append(`orderItems[${index}][feeForFormulating]`, 0);
                }
            }
        });

        createOrder({ data: formData }).then(() => {
            setCustomAlert({
                title: '¡Operacion Exitosa!',
                severity: 'success',
                message: 'El pedido fue creado exitosamente.',
                show: true
            });
            deleteAutoSave({
                data: { for: 'order' }
            })
                .catch(err => console.log("Error borrando autosave (ignorado):", err)) // Si falla, solo avisa en consola
                .finally(() => {
                    // 👇 ESTO SE EJECUTA SIEMPRE (Haya error o no)
                    localStorage.setItem('show_satisfaction_survey', 'true');
                    navigate('/mis-pedidos');
                });
        });
    }

    return (
        <div
            className="position-fixed"
            onClick={handleOverlay}
            style={{ display: show ? 'block' : 'none', background: "rgba(0,0,0, .4)", width: '100%', height: '100%', left: 0, top: 0, zIndex: 10 }}
        >
            <div ref={overlayRef} className="row justify-content-end" style={{ height: '100%' }}>
                <div className="col-lg-5 h-100 animate__animated animate__slideInRight" style={{ background: background?.value === 'light' ? 'white' : '#171622', overflow: 'auto' }}>
                    <div className="p-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">
                                Detalle del pedido
                            </h4>
                            <button className="btn btn-danger" onClick={() => setShow(false)}>
                                <FaTimes />
                            </button>
                        </div>
                        <br />
                        <div className="d-flex justify-content-between align-items-center mb-5">
                            <h4 className="mb-0">
                                Servicio:
                            </h4>
                            <h4 className="mb-0">
                                {data?.service?.name}
                            </h4>
                        </div>
                        <div className="text-center mt-2">
                            <h4 style={{ marginBottom: 0 }}>
                                Items de la orden
                            </h4>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-order text-center" style={{ fontSize: '10px' }}>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Código</th>
                                        <th width={"30%"} colSpan={2}>Item</th>
                                        <th>Cant.</th>
                                        <th>Precio</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data?.orderItems?.length > 0 ?
                                            data?.orderItems?.map((item, i) => {
                                                return (
                                                    <CreateOrderItemRow
                                                        onChange={(e, i) => handleArrayChange(e, i, 'orderItems')}
                                                        index={i}
                                                        item={item}
                                                        onRemove={handleRemove}
                                                    />
                                                )
                                            })
                                            :
                                            <tr className="text-center">
                                                <td colSpan={7} style={{ fontSize: 15 }}>
                                                    <p>{`Añada items a la orden`}</p>
                                                </td>
                                            </tr>
                                    }
                                    <tr>
                                        <td colSpan={5}>
                                            <h3>Total:</h3>
                                        </td>
                                        <td colSpan={2}>
                                            <h3>{safeFormatCLP(total)}</h3>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {
                            data?.orderTypeId != 3 &&
                            <div className="mb-3">
                                <label className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        style={{ cursor: 'pointer' }}
                                        checked={data?.saveTemplate}
                                        onChange={(e) => {
                                            setData((oldData) => {
                                                return {
                                                    ...oldData,
                                                    saveTemplate: !oldData?.saveTemplate
                                                }
                                            })
                                        }}
                                    />
                                    <span style={{ marginLeft: 10 }}>
                                        ¿Guardar este pedido como plantilla?
                                    </span>
                                </label>
                            </div>
                        }
                        <button type="button" className="btn btn-danger w-100 mb-3" onClick={() => setShow(false)}>
                            Cerrar
                        </button>
                        <button disabled={createLoading} onClick={handleCreateOrder} className="btn btn-primary mb-3 w-100">
                            {
                                createLoading ?
                                    'Cargando...'
                                    :
                                    'Crear Pedido'
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrderSidebar;